import { memo } from 'react'

import { usdLargeNumberFormatter } from '@repo/common/helpers/formatters'
import { useGetFundTVL } from '@repo/common/queries/funds'
import {
  type AllFundSymbol,
  type FundSymbol,
  isActiveFund,
} from '@repo/common/queries/products'

const ActiveFundTVL = memo<{ symbol: FundSymbol }>(function ActiveFundTVL({
  symbol,
}) {
  const { tvl, isLoading } = useGetFundTVL({ symbol })
  if (isLoading) return null

  return (
    <>
      {usdLargeNumberFormatter(tvl, {
        maximumFractionDigits: 2,
      })}
    </>
  )
})

export const FundTVL = memo<{ symbol: AllFundSymbol }>(function FundTVL({
  symbol,
}) {
  if (isActiveFund(symbol)) {
    return <ActiveFundTVL symbol={symbol as FundSymbol} />
  }

  return 'n/a'
})
